import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

import "./CustomSmallerIconDatePicker.sass";


const CustomSmallerIconDatePicker = (props) => {
  const {
    label,
    value,
    onChange,
    minDate,
    maxDate,
    onOperatorChange,
    defaultOperator = "=",
    showOperators = false,
    operatorLabel,
  } = props;

  const [date, setDate] = useState(value);
  const [operator, setOperator] = useState(defaultOperator);
  const { t } = useTranslation();

  useEffect(() => {
    setDate(value || null);
  }, [value]);

  const handleDateChange = (val) => {
    const newDate = val?.$d || null;
    setDate(newDate);
    onChange && onChange({ date: newDate, operator });
  };

  const handleTodayClick = () => {
    const today = dayjs();
    setDate(today.$d);
  };

  const handleClearClick = () => {
    setDate(null);
    onChange && onChange({ date: null, operator });
  };

  const handleOperatorChange = (event) => {
    const newOperator = event.target.value;
    setOperator(newOperator);
    onOperatorChange && onOperatorChange(newOperator, date);
    onChange && onChange({ date, operator: newOperator });
  };

  const CustomCalendarHeader = () => {
    if (!showOperators) return null;

    return (
      <Box className="operator_box">
        <Typography variant="body2" className="operator_typography">
          {operatorLabel}
        </Typography>
        <RadioGroup
          row
          value={operator}
          onChange={handleOperatorChange}
          className="operator_radio_grp"
        >
          <FormControlLabel
            value="="
            control={<Radio size="small" />}
            label="="
          />
          <FormControlLabel
            value="<"
            control={<Radio size="small" />}
            label="<"
          />
          <FormControlLabel
            value=">"
            control={<Radio size="small" />}
            label=">"
          />
        </RadioGroup>
      </Box>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={date}
        onChange={handleDateChange}
        minDate={minDate}
        maxDate={maxDate}
        PaperProps={{
          className: "date_picker_container",
        }}
        components={{
          PaperContent: (paperProps) => (
            <Paper {...paperProps}>
              <CustomCalendarHeader />
              {paperProps.children}
              <Box className="date_button_box">
                <Button 
                  size="small" 
                  variant="outlined" 
                  onClick={handleTodayClick}
                  fullWidth
                >
                  {t('today')}
                </Button>
                <Button 
                  size="small" 
                  variant="outlined" 
                  color="error"
                  onClick={handleClearClick}
                  fullWidth
                >
                  {t('clear')}
                </Button>
              </Box>
            </Paper>
          ),
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            className="data_picker_text"
            size="small"
            fullWidth
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomSmallerIconDatePicker;
